"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContactModal;
var _react = _interopRequireWildcard(require("react"));
var Yup = _interopRequireWildcard(require("yup"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _ComposeDialog = require("./ComposeDialog");
var _SocialAnchor = require("./components/SocialAnchor");
var _ContactForm = require("./ContactForm");
var _ModalErrors = require("./modal/ModalErrors");
var _InputField = require("./components/InputField");
var _Request = require("./Request");
var _GitHub = _interopRequireDefault(require("./buttons/GitHub"));
var _Google = _interopRequireDefault(require("./buttons/Google"));
var _Twitter = _interopRequireDefault(require("./buttons/Twitter"));
var _LinkedIn = _interopRequireDefault(require("./buttons/LinkedIn"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*
 * - Use dict for stepNumber
 * - Use reducer
 * - Breadcrumbs
 *
 */

function ContactModal(_ref) {
  var apiEndpoint = _ref.apiEndpoint,
    dialogOpen = _ref.dialogOpen,
    closeDialog = _ref.closeDialog;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    transitioning = _useState2[0],
    setTransitioning = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    loginUrls = _useState4[0],
    setLoginUrls = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    profile = _useState6[0],
    setProfile = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    responseError = _useState8[0],
    setResponseError = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    stepNumber = _useState10[0],
    setStepNumber = _useState10[1];
  var makeApiEndpoint = function makeApiEndpoint(name) {
    return "".concat(apiEndpoint).concat(name, "/");
  };
  var messageEndpoint = makeApiEndpoint("message");
  var sessionEndpoint = makeApiEndpoint("session");
  var userEndpoint = makeApiEndpoint("user");
  var request = (0, _Request.Request)({
    sessionEndpoint: sessionEndpoint,
    setLoginUrls: setLoginUrls,
    setResponseError: setResponseError,
    setProfile: setProfile
  });
  var getSocketUrl = (0, _react.useCallback)(function () {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve("ws://localhost:8888/chat/test/");
      }, 2000);
    });
  }, []);
  var Reset = function Reset(formik) {
    // try https://formik.org/docs/api/withFormik
    closeDialog();
    if (formik) {
      formik.resetForm();
    }
  };
  var logout = function logout() {
    request.logout(function () {
      setStepNumber(0);
      Reset();
    });
  };
  var Errors = function Errors() {
    var searchParams = new URLSearchParams(window.location.search);
    var error = searchParams.get("error_description");
    if (error === null) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    var responseError = {
      errors: [Object.create({
        detail: error
      })]
    };
    return /*#__PURE__*/_react.default.createElement(_ModalErrors.ModalErrors, {
      responseError: responseError
    });
  };
  var SocialButtons = function SocialButtons() {
    var mappings = {
      github: /*#__PURE__*/_react.default.createElement(_GitHub.default, null),
      google: /*#__PURE__*/_react.default.createElement(_Google.default, null),
      linkedin: /*#__PURE__*/_react.default.createElement(_LinkedIn.default, null),
      twitter: /*#__PURE__*/_react.default.createElement(_Twitter.default, null)
    };
    var buttons = [];
    Object.keys(loginUrls).forEach(function (network) {
      var button = mappings[network];
      buttons.push( /*#__PURE__*/_react.default.createElement(_SocialAnchor.SocialAnchor, {
        key: network,
        href: loginUrls[network]
      }, button));
    });
    return buttons;
  };
  return /*#__PURE__*/_react.default.createElement(_ContactForm.ContactForm, {
    request: request,
    profile: profile,
    responseError: responseError,
    initialValues: {
      email: "",
      name: ""
    },
    dialogOpen: dialogOpen,
    closeDialog: closeDialog,
    transitioning: transitioning,
    setTransitioning: setTransitioning,
    stepNumber: stepNumber,
    setStepNumber: setStepNumber,
    Reset: Reset,
    logout: logout
  }, /*#__PURE__*/_react.default.createElement(_ContactForm.ModalStep, {
    name: "connect",
    title: "Let's connect",
    endpoint: userEndpoint,
    validationSchema: Yup.object({
      name: Yup.string().max(100, "Must be 100 characters or less").required("required"),
      email: Yup.string().email("Invalid email address").required("required")
    })
  }, /*#__PURE__*/_react.default.createElement(Errors, null), /*#__PURE__*/_react.default.createElement(SocialButtons, null), process.env.REACT_APP_EMAIL_REGISTRATION === "true" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      marginTop: "16px",
      flexGrow: 1,
      textAlign: "center"
    }
  }, /*#__PURE__*/_react.default.createElement("u", null, "Or"), " enter your email address", " ", /*#__PURE__*/_react.default.createElement("em", null, "(verification required)"), ":"), /*#__PURE__*/_react.default.createElement(_InputField.InputField, {
    label: "Email Address",
    type: "email",
    name: "email"
  }))), /*#__PURE__*/_react.default.createElement(_ContactForm.ModalStep, {
    name: "compose",
    title: "Compose Message",
    endpoint: messageEndpoint,
    validationSchema: Yup.object({
      subject: Yup.string().max(100, "Must be 100 characters or less").required("Required"),
      body: Yup.string().min(5, "Must be 5 characters or more").max(10000, "Must be 10000 characters or less").required("Required")
    })
  }, /*#__PURE__*/_react.default.createElement(_ComposeDialog.ComposeDialog, {
    profile: profile
  })), /*#__PURE__*/_react.default.createElement(_ContactForm.ModalStep, {
    name: "confirm"
  }));
}
ContactModal.propTypes = {
  apiEndpoint: _propTypes.default.string,
  dialogOpen: _propTypes.default.bool,
  closeDialog: _propTypes.default.func
};